/**
 * Scripts spécifiques à la page d'accueil.
 */
// Importer les javascripts généraux
import "./main";
//importer les modules utiles
import MediaQuery from "./modules/media_query";
// Importer Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
// Importer Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
// Caroussel "above the fold" de la page d'accueil
// init Swiper:
const swiperCaroussel = new Swiper('#hero-carrousel', {
    // Optional parameters
    loop: true,
    // configure Swiper to use modules
    modules: [Autoplay, Navigation],
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    // Module autoplay
    autoplay: {
        delay: 7000, // délais en millisecondes
        disableOnInteraction: true,
    },
});
// Caroussel "flip cards" de la page d'accueil
const mediaQuery = new MediaQuery(3); // Init l'objet qui permet de déterminer la taille de l'écran; afficher 3 cartes (desktop)
// init Swiper:
const swiperCards = new Swiper('#carrousel-flip-cards-accueil', {
    // configure Swiper to use modules
    modules: [Navigation],
    // Optional parameters
    loop: true,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    slidesPerView: mediaQuery.handleScreenChange(),
});
// Animer les cartes "onclick"
var cartes = document.querySelectorAll('.flip-card__wrapper');
[...cartes].forEach((carte) => {
    carte.addEventListener('click', function (ev) {
        // Empêcher le retournement de la carte lorsqu'on clique sur le CTA
        const cta = carte.querySelector('a.diapo-carte__cta');
        if (cta == ev.target) {
            return;
        }
        // Appliquer le style qui fait tourner la carte
        carte.classList.toggle('flip-card__wrapper--is-flipped');
    });
});
